import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// Consistent dark "globe" hero band used across secondary pages.
export default function PageHero({ overline, title, subtitle, icon: Icon, crumb }) {
  return (
    <section className="relative overflow-hidden bg-[#070b18] border-b border-border">
      <img src="/hero-bg.jpg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-60" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#070b18] via-[#070b18]/85 to-[#070b18]/40" />
      <div className="hero-glow hero-glow-1" />
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 py-14 sm:py-16">
        {crumb && (
          <div className="flex items-center gap-1 text-xs text-white/50 mb-4">
            <Link to="/" className="hover:text-white transition-colors">Home</Link>
            <ChevronRight className="h-3 w-3" />
            <span className="text-white/80">{crumb}</span>
          </div>
        )}
        {overline && (
          <div className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-semibold text-[#8ba0ff] mb-4">
            {Icon && <Icon className="h-4 w-4" />} {overline}
          </div>
        )}
        <h1 className="font-serif text-4xl sm:text-5xl font-extrabold tracking-tight leading-[1.05] text-white">
          {title}
        </h1>
        {subtitle && (
          <p className="text-base sm:text-lg text-white/70 mt-4 max-w-2xl leading-relaxed">{subtitle}</p>
        )}
      </div>
    </section>
  );
}
